// @flow
import { Button } from "antd";
import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import pickBy from "lodash/pickBy";
import { useLoadResponseQueue } from "queries/response_queue/useLoadResponseQueue";
import * as React from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import Page from "ui/organisms/Page";
import { ContextTabletMode } from "utils/ContextTabletMode";
import { isFilledArray } from "utils/helpers";

function TabletModeMenu(): React.Node {
  const { sessions, setSessions } = React.useContext(ContextTabletMode);
  const { data: responseQueue, isLoading } = useLoadResponseQueue();
  const history = useHistory();

  const hasQueue = !isLoading && responseQueue?.length;

  const buttonList = [
    {
      label: "Start New Packet",
      to: "/t/p",
      disabled: false,
      loading: false,
      cypress: "start-packet-tablet",
    },
    {
      label: "Start New Form",
      to: "/t/f",
      disabled: false,
      loading: false,
      cypress: "start-form-tablet",
    },
    {
      label: "Queue",
      to: "/t/q",
      disabled: !hasQueue,
      loading: isLoading,
      cypress: "start-queue-tablet",
    },
  ];

  React.useEffect(() => {
    const filteredFillSessions = pickBy(
      sessions,
      ({ isWaiting, isSubmitted, customer, responses }) =>
        isWaiting === false &&
        isSubmitted === false &&
        !isNil(customer) &&
        isFilledArray(responses),
    );
    if (!isEqual(filteredFillSessions, sessions)) {
      setSessions(filteredFillSessions);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Helmet>
        <title>Tablet Mode/Zentake</title>
      </Helmet>
      <Page centerContainer centerTitle title="Tablet Mode">
        <div className="flex flex-col gap-4 items-center justify-center">
          {buttonList.map(({ to, disabled, loading, label, cypress }) => (
            <Button
              className="w-60"
              data-cy={cypress}
              disabled={disabled}
              key={label}
              loading={loading}
              onClick={() => history.push(to)}
              type="primary"
            >
              {label}
            </Button>
          ))}
        </div>
      </Page>
    </>
  );
}

export default TabletModeMenu;
